
import * as Yup from "yup";


export interface ExperienciaLaboralItemForm {
    tipo: string,
    nombreEmpresaInstitucion: string,
    fechaInicio: string,
    fechaFin: string
    resumenFunciones: string
    nombreJefeInmediato: string
    soporteId: string
    cargo: string
}

export interface IExperienciaLaboralForm {
  experienciasLaborales: ExperienciaLaboralItemForm[]
}

// Esquema de validación
export const esquemaDeValidacionExperiencia = Yup.object().shape({
    experienciasLaborales: Yup.array().of(
      Yup.object().shape({
        tipo: Yup.string().required("El tipo de experiencia es obligatorio"),
        nombreEmpresaInstitucion: Yup.string().required("El nombre de la empresa es obligatorio"),
        fechaInicio: Yup.string().required("La fecha de inicio es obligatoria"),
        cargo: Yup.string().required("El cargo es obligatorio"),
        fechaFin:Yup.string().required("La fecha de finalización es obligatoria"),
        resumenFunciones:Yup.string().required("El resumen de funciones es obligatorio"),
        nombreJefeInmediato:Yup.string().required("El nombre del jefe inmediato es obligatorio"),
        soporteId:Yup.string().required("El certificado es obligatorio"),
      })
    ),
  });
  
  // Valores iniciales
  export const valoresInicialesEsperienciaLaboral: IExperienciaLaboralForm = {
    experienciasLaborales: [
      { 
        tipo: "",
        nombreEmpresaInstitucion: '',
        fechaInicio: '',
        fechaFin: '',
        resumenFunciones: '',
        nombreJefeInmediato: '',
        soporteId: '',
        cargo: ''
    },
    ],
  };